import React from 'react';
import { IconButton } from '@material-ui/core';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';

export default props => (
  <IconButton {...props} aria-label="edit">
    <DeleteForeverOutlinedIcon />
  </IconButton>
);
